<h5>
  {{
    'company-tool.views.jobs.posting.sections.publication.job-markets.recommended-jobs.title'
      | transloco
  }}
  @if (jobPlatformsService.recommendedPlatformsLoading()) {
    <ct-lib-spinner></ct-lib-spinner>
  }
</h5>
@if (
  ('company-tool.views.jobs.posting.sections.publication.job-markets.recommended-jobs.description'
    | transloco) !== ' '
) {
  <ct-lib-info-banner>
    <span
      [innerHTML]="
        'company-tool.views.jobs.posting.sections.publication.job-markets.recommended-jobs.description'
          | transloco
      "
    >
    </span>
  </ct-lib-info-banner>
}
@if (!screenService.isMobile) {
  <div class="table-wrapper mt-3">
    <div class="actions">
      <app-button
        id="job-posting-publish-channels-more"
        [iconStart]="fontawesomeService.light.plus"
        (click)="jobPlatformsModal.open()"
      >
        {{
          'company-tool.views.jobs.posting.sections.publication.add-more-markets'
            | transloco
        }}
      </app-button>
    </div>
    <p-table
      id="job-posting-publish-recommended-channels"
      class="jobplatforms"
      [value]="displayedJobPlatforms()"
    >
      <ng-template #header>
        <tr>
          <th style="width: 10%"></th>
          <th>
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.portal'
                | transloco
            }}
          </th>
          <th style="width: 10%" class="text-center">
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.duration'
                | transloco
            }}
          </th>
          <th style="width: 10%" class="text-center">
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.price'
                | transloco
            }}
          </th>
          <th style="width: 10%" class="text-center">
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.delivery-time'
                | transloco
            }}
          </th>
          <th style="width: 10%" class="text-center">
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.publish'
                | transloco
            }}
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-jobPlatform>
        <tr>
          <td>
            <img
              [src]="jobPlatform.logoURL"
              [alt]="'Logo - ' + jobPlatform.title"
              loading="lazy"
            />
          </td>
          <td>
            <b>{{ jobPlatform.title }}</b>
            <span class="ms-2">
              @if (jobPlatform.crossPostings.length > 0) {
                <fa-icon
                  class="cross-posting-icon"
                  [icon]="fontawesomeService.light.shareNodes"
                  (click)="
                    openJobCrossPostingModal(
                      jobCrossPostingModal,
                      jobPlatform
                    )
                  "
                ></fa-icon>
              }
            </span>
            @if (jobPlatform.description) {
              <br />
              <span>
                {{
                  isDescriptionOpen(jobPlatform.id)
                    ? jobPlatform.description
                    : jobPlatform.description.slice(0, 100) + '...'
                }}
              </span>
              <span>
                @if (isDescriptionOpen(jobPlatform.id)) {
                  <a (click)="closeDescription(jobPlatform.id)">{{
                    'company-tool.views.jobs.posting.sections.publication.job-markets.show.less'
                      | transloco
                  }}</a>
                } @else {
                  <a (click)="openDescription(jobPlatform.id)">
                    {{
                      'company-tool.views.jobs.posting.sections.publication.job-markets.show.more'
                        | transloco
                    }}
                  </a>
                }
              </span>
            }
          </td>
          <td class="text-center">
            @if (
              jobPlatform.duration !== null && !isNaN(jobPlatform.duration)
            ) {
              <span>
                {{ ceiling(jobPlatform.duration) }}
                {{
                  'company-tool.views.jobs.posting.sections.publication.job-markets.days'
                    | transloco
                }}
              </span>
            } @else {
              <fa-icon [icon]="fontawesomeService.light.infinity"></fa-icon>
            }
          </td>
          <td class="text-center">
            @if (jobPlatform.price === 0) {
              <span>{{
                'company-tool.views.jobs.posting.sections.publication.job-markets.free'
                  | transloco
              }}</span>
            } @else {
              <span>{{ jobPlatform.price | formatPrice }}</span>
            }
          </td>
          <td class="text-center">
            {{
              isNaN(jobPlatform.totalDeliveryTimePerDays)
                ? jobPlatform.totalDeliveryTimePerDays
                : ceiling(jobPlatform.totalDeliveryTimePerDays)
            }}
            {{
              'company-tool.views.jobs.posting.sections.publication.job-markets.days'
                | transloco
            }}
          </td>
          <td class="text-center" id="job-posting-publish-channels-check">
            <input
              type="checkbox"
              [checked]="isPlatformSelected(jobPlatform)"
              (change)="onPlatformSelectionChange(jobPlatform)"
            />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}

@if (screenService.isMobile) {
  <ul class="platformlist-mobile">
    @for (
      jobPlatform of displayedJobPlatforms();
      track trackPlatformsBy($index, jobPlatform)
    ) {
      <li>
        <div>
          <input
            type="checkbox"
            [checked]="isPlatformSelected(jobPlatform)"
            (change)="onPlatformSelectionChange(jobPlatform)"
          />
        </div>
        <img
          [src]="jobPlatform.logoURL"
          [alt]="'Logo - ' + jobPlatform.title"
          loading="lazy"
        />
        <div>
          <h5>{{ jobPlatform.title }}</h5>
          <div>
            <ct-lib-tag>
              <fa-icon [icon]="fontawesomeService.light.euroSign"></fa-icon>
              @if (jobPlatform.price === 0) {
                <span>
                  {{
                    'company-tool.views.jobs.posting.sections.publication.job-markets.free'
                      | transloco
                  }}
                </span>
              } @else {
                <span
                  >{{ jobPlatform.price | formatPrice
                  }}{{ jobPlatform.price | currency: 'EUR' }}</span
                >
              }
            </ct-lib-tag>
            <ct-lib-tag>
              <fa-icon [icon]="fontawesomeService.light.clock"></fa-icon>
              @if (
                jobPlatform.duration !== null && !isNaN(jobPlatform.duration)
              ) {
                <span>
                  {{ ceiling(jobPlatform.duration) }}
                  {{
                    'company-tool.views.jobs.posting.sections.publication.job-markets.days'
                      | transloco
                  }}
                </span>
              } @else {
                <fa-icon [icon]="fontawesomeService.light.infinity"></fa-icon>
              }
            </ct-lib-tag>
          </div>
        </div>
      </li>
    }
  </ul>
  <app-button
    variant="white-grey"
    id="job-posting-publish-channels-more"
    [iconStart]="fontawesomeService.light.arrowRight"
    (click)="jobPlatformsModal.open()"
  >
    {{
      'company-tool.views.jobs.posting.sections.publication.add-more-markets'
        | transloco
    }}
  </app-button>
}

<ct-lib-modal
  [label]="
    'company-tool.views.jobs.posting.sections.publication.add-more-markets'
      | transloco
  "
  class="jobplatforms-modal"
  #jobPlatformsModal
  [footer]="jobPlatformsModalFooter"
>
  <div class="jobplatforms-search">
    <div class="row">
      <div class="col-12 form-group">
        <input
          class="form-control"
          [placeholder]="
            'company-tool.views.jobs.posting.sections.publication.job-markets.modal.form.search.placeholder'
              | transloco
          "
          [formControl]="jobPlatformFilter"
          #jobPlatformFilterInput
        />
      </div>
    </div>
  </div>
  <div class="table-wrapper">
    <div class="table-overflow-wrapper">
      <p-table
        #jobPlatformsTable
        class="jobplatforms"
        [value]="jobPlatformsService.platforms()"
        [paginator]="true"
        [rows]="rows()"
        [hidden]="jobPlatformsService.platformsLoading()"
        [totalRecords]="jobPlatformsService.platformsTotal()"
        [(first)]="offset"
        [lazy]="true"
        (onLazyLoad)="onPaginationChange($event)"
        dataKey="id"
        responsiveLayout="stack"
        breakpoint="768px"
      >
      <ng-template #header>
        <tr>
          <th></th>
          <th>
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.portal'
                | transloco
            }}
          </th>
          <th class="text-center">
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.duration'
                | transloco
            }}
          </th>
          <th width="150px" class="text-center">
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.price'
                | transloco
            }}
          </th>
          <th>
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.delivery-time'
                | transloco
            }}
          </th>
          <th class="text-center">
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.publish'
                | transloco
            }}
          </th>
        </tr>
      </ng-template>

      <ng-template #body let-jobPlatform>
        @if (!isLoading) {
          <tr class="jobplatform">
            <td>
              <img
                [src]="jobPlatform.logoURL"
                [alt]="'Logo - ' + jobPlatform.title"
                loading="lazy"
              />
            </td>
            <ng-container>
              <td>
                <b>{{ jobPlatform.title }}</b>
                <span class="ms-2">
                  @if (jobPlatform.crossPostings.length > 0) {
                    <fa-icon
                      class="cross-posting-icon"
                      [icon]="fontawesomeService.light.shareNodes"
                      (click)="
                        openJobCrossPostingModal(
                          jobCrossPostingModal,
                          jobPlatform
                        )
                      "
                    ></fa-icon>
                  }
                </span>
                @if (jobPlatform.description) {
                  <br />
                  <span>
                    {{
                      isDescriptionOpen(jobPlatform.id)
                        ? jobPlatform.description
                        : jobPlatform.description.slice(0, 100) + '...'
                    }}
                  </span>
                  <span>
                    @if (isDescriptionOpen(jobPlatform.id)) {
                      <a
                        class="description-toggle"
                        (click)="closeDescription(jobPlatform.id)"
                        >{{
                          'company-tool.views.jobs.posting.sections.publication.job-markets.show.less'
                            | transloco
                        }}</a
                      >
                    } @else {
                      <a
                        class="description-toggle"
                        (click)="openDescription(jobPlatform.id)"
                      >
                        {{
                          'company-tool.views.jobs.posting.sections.publication.job-markets.show.more'
                            | transloco
                        }}
                      </a>
                    }
                  </span>
                }
              </td>
            </ng-container>
            <td class="text-center">
              @if (
                jobPlatform.duration !== null && !isNaN(jobPlatform.duration)
              ) {
                {{ ceiling(jobPlatform.duration) }}
                {{
                  'company-tool.views.jobs.posting.sections.publication.job-markets.days'
                    | transloco
                }}
              } @else {
                <fa-icon [icon]="fontawesomeService.light.infinity"></fa-icon>
              }
            </td>
            <td class="text-center">
              {{
                jobPlatform.price === 0
                  ? ('company-tool.views.jobs.posting.sections.publication.job-markets.free'
                    | transloco)
                  : (jobPlatform.price | formatPrice)
              }}
            </td>
            <td class="text-center">
              {{
                isNaN(jobPlatform.totalDeliveryTimePerDays)
                  ? jobPlatform.totalDeliveryTimePerDays
                  : ceiling(jobPlatform.totalDeliveryTimePerDays)
              }}
              {{
                'company-tool.views.jobs.posting.sections.publication.job-markets.days'
                  | transloco
              }}
            </td>
            <td class="text-center">
              <input
                type="checkbox"
                [checked]="isPlatformSelected(jobPlatform)"
                (change)="onPlatformSelectionChange(jobPlatform)"
              />
            </td>
          </tr>
        } @else {
          <tr>
            <td colspan="6" class="text-center">
              <app-view-loader [loading]="isLoading"></app-view-loader>
            </td>
          </tr>
        }
      </ng-template>
      </p-table>
    </div>
    @if (jobPlatformsService.platformsLoading()) {
      <app-view-loader [loading]="true"></app-view-loader>
    }
  </div>
</ct-lib-modal>

<ng-template #jobPlatformsModalFooter>
  <app-button variant="primary" (click)="jobPlatformsModal.close()">
    {{
      'company-tool.views.jobs.posting.sections.publication.job-markets.modal.footer.confirm'
        | transloco
    }}
  </app-button>
</ng-template>

<ct-lib-modal
  [label]="
    'company-tool.views.jobs.posting.sections.publication.job-markets.cross-posting-modal.title'
      | transloco
  "
  class="jobplatforms-modal"
  #jobCrossPostingModal
>
  <div class="table-wrapper">
    <p-table [value]="jobCrossPostings">
      <ng-template #header>
        <tr>
          <th class="text-center">
            {{
              'company-tool.views.jobs.posting.sections.publication.table.headers.portal'
                | transloco
            }}
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-crossPosting>
        <tr>
          <td class="text-center">{{ crossPosting }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</ct-lib-modal>
